import * as t from 'ts-schema';
import getLang from 'I18n/utils/getLang';
import { registerQuery } from 'data-fetching-client';
import { detailsResponseSchema } from 'marketplace-ui-client-types/ecosystem-service-v1/schema';
import { getEcosystemClient } from 'marketplace-ui-common/clients/ecosystemClient';
import { getQuickFetch } from 'marketplace-ui-common/utils/earlyRequests';
export const APP_DETAILS_QUERY = registerQuery({
  fieldName: 'appDetails',
  args: ['appContext', 'slug'],
  fetcher: ({
    appContext,
    slug
  }) => getQuickFetch(`details:${slug}`).catch(() => {
    const client = getEcosystemClient(appContext === 'admin-preview' ? 'public' : appContext);
    const options = {
      query: {
        slug,
        language: getLang()
      }
    };
    return client.get('apps/details', options).then(response => t.assert(detailsResponseSchema, response));
  })
});